import { SAVE_MANAGER_MONTHDATA_SUCCESS } from "../Constants";

export default (state = { type: "", message: "" }, action) => {
  switch (action.type) {
    case SAVE_MANAGER_MONTHDATA_SUCCESS:
      return {
        type: "Timesheet Data submit Successfully",
        message: action.message
      };
    default:
      return state;
  }
};
